import React, { FC } from 'react';
import { CommentariesRestrictedModal } from './public/CommentariesRestrictedModal';
import { UserStatusRouter } from './UserStatusRouter';

type Props = {
  source: string;
  isOpen?: boolean;
  onRequestClose?: () => void;
};

export const RestrictedModalCommentaries: FC<Props> = ({
  source,
  isOpen = false,
  onRequestClose = () => {},
}) => (
  <UserStatusRouter
    onRequestClose={onRequestClose}
    isOpen={isOpen}
    source={source}
  >
    <CommentariesRestrictedModal source={source} closeModal={onRequestClose} />
  </UserStatusRouter>
);
